import * as Scrivito from "scrivito"

import { InstallationReferencePage } from "pages/building-reference-page/installation-reference-page/InstallationReferencePage"

import { InstallationReferenceObjClass } from "./InstallationReferenceObjClass"

Scrivito.provideComponent(
  InstallationReferenceObjClass,
  InstallationReferencePage
)
